import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, tokenKey, redirectPath }) => {
  const token = sessionStorage.getItem(tokenKey);

  if (!token) {
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default ProtectedRoute;
